import { Divider, InputNumber, Tooltip } from "antd";
import Form from "antd/lib/form/Form";
import { Formik } from "formik";
import React, { createContext, useContext, useRef } from "react";
import FormItem from "antd/lib/form/FormItem";
import ReactQuill from "react-quill";
import "../styles/quaibodaily.css";

import "react-quill/dist/quill.snow.css";
import QuaiboDailyProductionStore from "../store/quaibodailyproductionstore";
import { observer } from "mobx-react-lite";
import { toJS } from "mobx";

import formatNumber from "accounting-js/lib/formatNumber.js";
import { AgGridReact } from "ag-grid-react";

import { reactQuiltoolbarOptions } from "../../../Utility/modules/helpers";
import { MessageBar, MessageBarType } from "@fluentui/react";
const _ = require("underscore");
const QuaiboStoreCtx = createContext(QuaiboDailyProductionStore);
export const QuaiboDailyProductionForm = observer(() => {
  const quaiboDailyProductionStore = useContext(QuaiboStoreCtx);
  const formGrid = useRef(null);

  const getTotal = (col) =>
    formatNumber(
      _.reduce(
        _.pluck([...quaiboDailyProductionStore.wellparameters.values()], col),
        function (memo, num) {
          return (
            Number(memo) + Number(_.isNull(num) || _.isUndefined(num) ? 0 : num)
          );
        },
        0
      ),
      {
        precision: 4,
        thousand: ",",
      }
    );
  const wellParaColumns = [
    {
      headerName: "#",
      valueGetter: "node.rowIndex + 1",
      width: 50,
      resizable: true,
      sortable: true,
      pivot: false,
      editable: false,
      pinnedRowCellRenderer: (props) => {
        return "";
      },
    },
    {
      width: 80,
      hide: true,
      pivot: false,
      pinnedRowCellRenderer: (props) => {
        return "";
      },
    },
    {
      headerName: "Well",
      field: "wellName",
      sortable: true,
      resizable: true,
      editable: false,

      width: 150,
      pinnedRowCellRenderer: (props) => {
        return "Total Well Productions";
      },
      pinnedRowCellRendererParams: {
        style: { color: "red" },
      },
    },

    {
      headerName: 'Choke Size (/64")',
      field: "choke",
      width: 100,
      sortable: true,
      resizable: true,
      pinnedRowCellRenderer: (props) => {
        return "";
      },
    },
    {
      headerName: "Operating Hours",
      field: "operatingHrs",
      width: 100,
      sortable: true,
      resizable: true,
    },
    {
      headerName: "Flowing Tubing Head Pressure(Psi)",
      field: "fthp",
      width: 100,
      sortable: true,
      resizable: true,
      type: "numberColumn",
      cellStyle: { textAlign: "right" },
    },
    {
      headerName: "Wellhead Temperature(Deg F)",
      field: "wht",
      width: 100,
      sortable: true,
      resizable: true,
      type: "numberColumn",
      cellStyle: { textAlign: "right" },
    },
    {
      headerName: "Flowline Pressure (Psi)",
      field: "flp",
      width: 100,
      sortable: true,
      resizable: true,
      type: "numberColumn",
      cellStyle: { textAlign: "right" },
    },
    {
      headerName: "Annulus Pressure(psi)",
      field: "annulusPressure",
      width: 100,
      sortable: true,
      resizable: true,
      type: "numberColumn",
      cellStyle: { textAlign: "right" },
    },
    {
      headerName: "Gross Production (BLPD)",
      field: "blpd",
      width: 100,
      sortable: true,
      resizable: true,
      type: "numberColumn",
      cellStyle: { textAlign: "right" },
      pinnedRowCellRendererParams: {
        style: { color: "red" },
      },
      pinnedRowCellRenderer: (props) => {
        return quaiboDailyProductionStore.totalBLPD;
      },
    },
    {
      headerName: "Wellhead BS&W (%)",
      field: "bsw",
      width: 100,
      sortable: true,
      resizable: true,
      type: "numberColumn",
      cellStyle: { textAlign: "right" },
    },
    {
      headerName: "Gross CrudeProduction (BOPD)",
      field: "oil",
      width: 100,
      sortable: true,
      resizable: true,
      type: "numberColumn",
      cellStyle: { textAlign: "right" },
    },
    {
      headerName: "Produced Water (BWPD)",
      field: "water",
      width: 100,
      sortable: true,
      resizable: true,
      type: "numberColumn",
      cellStyle: { textAlign: "right" },
    },
    {
      headerName: "Gross gas Production (Mmscf)",
      field: "gas",
      width: 100,
      sortable: true,
      resizable: true,
      type: "numberColumn",
      cellStyle: { textAlign: "right" },
    },
    {
      headerName: "GOR (scf/bbl.)",
      field: "gor",
      width: 100,
      sortable: true,
      resizable: true,
      type: "numberColumn",
      cellStyle: { textAlign: "right" },
    },
    {
      headerName: "VSD Operating Frequency (Hz)",
      field: "vsdOperatingFreq",
      width: 100,
      sortable: true,
      resizable: true,
      type: "numberColumn",
      cellStyle: { textAlign: "right" },
    },
    {
      headerName: "ESP Intake Pressure(Psi)",
      field: "espIntake",
      width: 100,
      sortable: true,
      resizable: true,

      cellStyle: { textAlign: "right" },
    },
    {
      headerName: "ESP Discharge Pressure(Psi)",
      field: "espDischarge",
      width: 100,
      sortable: true,
      resizable: true,

      cellStyle: { textAlign: "right" },
    },
    {
      headerName: "Sand Production (lbs./bbl.)",
      field: "sandProduction",
      width: 100,
      sortable: true,
      resizable: true,

      cellStyle: { textAlign: "right" },
    },
    {
      headerName: "Water salinity (ppm)",
      field: "waterSalinity",
      width: 100,
      sortable: true,
      resizable: true,

      cellStyle: { textAlign: "right" },
    },
    {
      headerName: "API degree",
      field: "api",
      width: 100,
      sortable: true,
      resizable: true,
      type: "numberColumn",
      cellStyle: { textAlign: "right" },
    },
  ];
  return (
    <Formik
      initialValues={toJS(quaiboDailyProductionStore.initFormaData)}
      enableReinitialize={true}
    >
      {({ values }) => (
        <Form
          layout="vertical"
          labelAlign="left"
          style={{ background: "#fff", padding: "10px" }}
        >
          <div className="ms-Grid" dir="ltr">
            <div className="ms-Grid-row">
              <Divider>Production Figures</Divider>
              <div className="ms-Grid-col ms-sm3">
                <Tooltip title="Gross Crude Production to storage tank (BOPD)">
                  <FormItem
                    label="Gross Crude Production To Storage Tank (BOPD)"
                    labelAlign="left"
                    className="add-border"
                  >
                    <InputNumber
                      min={0}
                      style={{ minWidth: "60%" }}
                      name="blpd"
                      value={values?.blpd}
                      onChange={(value) => {
                        quaiboDailyProductionStore.initFormaData.blpd = value;
                      }}
                    />
                  </FormItem>
                </Tooltip>
              </div>

              <div className="ms-Grid-col ms-sm3">
                <Tooltip title="Net Crude Production  (bbl.)">
                  {" "}
                  <FormItem
                    label="Net Crude Production  (bbl.)"
                    labelAlign="left"
                    className="add-border"
                  >
                    <InputNumber
                      min={0}
                      style={{ minWidth: "60%" }}
                      name="oil"
                      value={values?.oil}
                      onChange={(value) => {
                        quaiboDailyProductionStore.initFormaData.oil = value;
                      }}
                    />
                  </FormItem>
                </Tooltip>
              </div>
              <div className="ms-Grid-col ms-sm3">
                <Tooltip title="Field Water Production (bbl.)">
                  <FormItem
                    label="Field Water Production (bbl.)"
                    labelAlign="left"
                    className="add-border"
                  >
                    <InputNumber
                      min={0}
                      style={{ minWidth: "60%" }}
                      name="water"
                      value={values?.water}
                      onChange={(value) => {
                        quaiboDailyProductionStore.initFormaData.water = value;
                      }}
                    />
                  </FormItem>
                </Tooltip>
              </div>

              <div className="ms-Grid-col ms-sm3">
                <Tooltip title="Condensate from Gas Plant (bopd) ">
                  <FormItem
                    label="Condensate (bopd)"
                    labelAlign="left"
                    className="add-border"
                  >
                    <InputNumber
                      min={0}
                      style={{ minWidth: "60%" }}
                      name="condensate"
                      value={values?.condensate}
                      onChange={(value) => {
                        quaiboDailyProductionStore.initFormaData.condensate =
                          value;
                      }}
                    />
                  </FormItem>
                </Tooltip>
              </div>
            </div>
            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-sm3">
                <Tooltip title="Daily Gas Production (Mmscf)">
                  <FormItem
                    label="Daily Gas Production (Mmscf)"
                    labelAlign="left"
                    className="add-border"
                  >
                    <InputNumber
                      min={0}
                      style={{ minWidth: "60%" }}
                      name="gas"
                      value={values?.gas}
                      onChange={(value) => {
                        quaiboDailyProductionStore.initFormaData.gas = value;
                      }}
                    />
                  </FormItem>
                </Tooltip>
              </div>

              <div className="ms-Grid-col ms-sm3">
                <Tooltip title="Fuel Gas Consumed in Operations (Mmscfd)">
                  <FormItem
                    label="Fuel Gas (Mmscfd)"
                    labelAlign="left"
                    className="add-border"
                  >
                    <InputNumber
                      min={0}
                      style={{ minWidth: "60%" }}
                      name="fuelGas"
                      value={values?.fuelGas}
                      onChange={(value) => {
                        quaiboDailyProductionStore.initFormaData.fuelGas =
                          value;
                      }}
                    />
                  </FormItem>
                </Tooltip>
              </div>
              <div className="ms-Grid-col ms-sm3">
                <Tooltip title="Utilized Gas (Mmscf/d)">
                  <FormItem
                    label="Utilized Gas (Mmscf/d)"
                    labelAlign="left"
                    className="add-border"
                  >
                    <InputNumber
                      min={0}
                      style={{ minWidth: "60%" }}
                      name="ownUseGas"
                      value={values?.ownUseGas}
                      onChange={(value) => {
                        quaiboDailyProductionStore.initFormaData.ownUseGas =
                          value;
                      }}
                    />
                  </FormItem>
                </Tooltip>
              </div>
              <div className="ms-Grid-col ms-sm3">
                <Tooltip title="Flared Gas (Mmscfd)">
                  <FormItem
                    label="Flared (Mmscfd)"
                    labelAlign="left"
                    className="add-border"
                  >
                    <InputNumber
                      min={0}
                      style={{ minWidth: "60%" }}
                      name="flareGas"
                      value={values?.flareGas}
                      onChange={(value) => {
                        quaiboDailyProductionStore.initFormaData.flareGas =
                          value;
                      }}
                    />
                  </FormItem>
                </Tooltip>
              </div>
            </div>

            <div className="ms-Grid-row">
              <Divider>Evacuation Figures</Divider>
              <div className="ms-Grid-col ms-sm4">
                <Tooltip title="Crude Injection to GGF (bbl.) GIV.">
                  <FormItem
                    label="Crude Injection to GGF (bbl.) GIV."
                    labelAlign="left"
                    className="add-border"
                  >
                    <InputNumber
                      min={0}
                      style={{ minWidth: "60%" }}
                      name="crudeInjectionGGF"
                      value={values?.crudeInjectionGGF}
                      onChange={(value) => {
                        quaiboDailyProductionStore.initFormaData.crudeInjectionGGF =
                          value;
                      }}
                    />
                  </FormItem>
                </Tooltip>
              </div>

              <div className="ms-Grid-col ms-sm4">
                <Tooltip title="Drained water from ABJ 400&500 (bbl.) ">
                  <FormItem
                    label="Drained water from ABJ 400&500 (bbl.)"
                    labelAlign="left"
                  >
                    <InputNumber
                      min={0}
                      style={{ minWidth: "60%" }}
                      name="drainedWater"
                      value={values?.drainedWater}
                      onChange={(value) => {
                        quaiboDailyProductionStore.initFormaData.drainedWater =
                          value;
                      }}
                    />
                  </FormItem>
                </Tooltip>
              </div>
              <div className="ms-Grid-col ms-sm4">
                <Tooltip title="Evacuated Gas (Mmscf/d)">
                  <FormItem label="Evacuated Gas (Mmscf/d)" labelAlign="left">
                    <InputNumber
                      min={0}
                      style={{ minWidth: "60%" }}
                      name="evacuatedGas"
                      value={values?.evacuatedGas}
                      onChange={(value) => {
                        quaiboDailyProductionStore.initFormaData.evacuatedGas =
                          value;
                      }}
                    />
                  </FormItem>
                </Tooltip>
              </div>
            </div>
            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-sm4">
                <Tooltip title="Evacuation Uptime (hrs)">
                  <FormItem label="Evacuation Uptime (hrs)" labelAlign="left">
                    <InputNumber
                      min={0}
                      style={{ minWidth: "60%" }}
                      name="evacuationUptime"
                      value={values?.evacuationUptime}
                      onChange={(value) => {
                        quaiboDailyProductionStore.initFormaData.evacuationUptime =
                          value;
                      }}
                    />
                  </FormItem>
                </Tooltip>
              </div>
              <div className="ms-Grid-col ms-sm4">
                <Tooltip title="Evacuated Condensate(bopd)">
                  <FormItem
                    label="Evacuated Condensate(bopd)"
                    labelAlign="left"
                  >
                    <InputNumber
                      min={0}
                      style={{ minWidth: "60%" }}
                      name="evacuatedCondensate"
                      value={values?.evacuatedCondensate}
                      onChange={(value) => {
                        quaiboDailyProductionStore.initFormaData.evacuatedCondensate =
                          value;
                      }}
                    />
                  </FormItem>
                </Tooltip>
              </div>
            </div>

            <div className="ms-Grid-row">
              <Divider>Other Station Figures</Divider>
              <div className="ms-Grid-col ms-sm4">
                <Tooltip title="Station Operating Hrs.">
                  <FormItem label="Operating Hrs." labelAlign="left">
                    <InputNumber
                      min={0}
                      style={{ minWidth: "60%" }}
                      name="operatingHrs"
                      value={values?.operatingHrs}
                      onChange={(value) => {
                        quaiboDailyProductionStore.initFormaData.operatingHrs =
                          value;
                      }}
                    />
                  </FormItem>
                </Tooltip>
              </div>
              <div className="ms-Grid-col ms-sm4">
                <Tooltip title="Produced Oil Gravity °API @ 60 ">
                  <FormItem
                    label="Produced Oil Gravity °API @ 60"
                    labelAlign="left"
                  >
                    <InputNumber
                      min={0}
                      style={{ minWidth: "60%" }}
                      name="stationAPI"
                      value={values?.stationAPI}
                      onChange={(value) => {
                        quaiboDailyProductionStore.initFormaData.stationAPI =
                          value;
                      }}
                    />
                  </FormItem>
                </Tooltip>
              </div>
              <div className="ms-Grid-col ms-sm4">
                <Tooltip title="Station BS&W (%) ">
                  <FormItem label="Station BS&W (%)" labelAlign="left">
                    <InputNumber
                      min={0}
                      style={{ minWidth: "60%" }}
                      name="bsw"
                      value={values?.bsw}
                      onChange={(value) => {
                        quaiboDailyProductionStore.initFormaData.bsw = value;
                      }}
                    />
                  </FormItem>
                </Tooltip>
              </div>

              <div className="ms-Grid-col ms-sm4">
                <Tooltip title="GOR(scf/bbl.) ">
                  <FormItem label="GOR(scf/bbl.)" labelAlign="left">
                    <InputNumber
                      min={0}
                      style={{ minWidth: "60%" }}
                      name="gor"
                      value={values?.gor}
                      onChange={(value) => {
                        quaiboDailyProductionStore.initFormaData.gor = value;
                      }}
                    />
                  </FormItem>
                </Tooltip>
              </div>
            </div>

            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-sm12">
                <Tooltip title="Remarks or Comments from the field  ">
                  <FormItem label="PRODUCTION REMARKS" labelAlign="left">
                    <ReactQuill
                      modules={{ toolbar: reactQuiltoolbarOptions }}
                      onChange={(value) => {
                        quaiboDailyProductionStore.initFormaData.remarks =
                          value;
                      }}
                      value={quaiboDailyProductionStore.initFormaData?.remarks}
                      style={{ minHeight: "300px" }}
                      placeholder="Enter REMARKS here"
                    />{" "}
                  </FormItem>{" "}
                </Tooltip>
              </div>
            </div>

            <Divider>Well Production Contributions</Divider>
            <MessageBar messageBarType={MessageBarType.info}>Double click table cell to edit value</MessageBar>
            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-sm12">
                <div
                  className="ag-theme-balham qikreach-grid-fill"
                  style={{
                    minHeight: "30vh",
                    height: "40vh",
                    width: "100%",
                    maxHeight: "80vh",
                  }}
                >
                  <AgGridReact
                    rowData={[
                      ...quaiboDailyProductionStore.wellparameters.values(),
                    ]}
                    ref={formGrid}
                    gridOptions={{
                      defaultColDef: {
                        sortable: true,
                        editable: true,
                        enableValue: true,
                        filter: true,
                      },

                      rowSelection: "single",
                      pagination: true,
                      columnDefs: wellParaColumns,
                      animateRows: true,
                      statusBar: {
                        statusPanels: [
                          {
                            statusPanel: "agTotalRowCountComponent",
                            align: "center",
                          },
                        ],
                      },
                      columnTypes: {
                        numberColumn: {
                          width: 130,
                          filter: "agNumberColumnFilter",
                        },

                        nonEditableColumn: { editable: false },
                      },
                    }}
                    rowSelection={{ mode: "singleRow", checkboxes: true, enableClickSelection: true }}
                    copyHeadersToClipboard={true}
                    pinnedBottomRowData={[
                      {
                        blpd: getTotal("blpd"),
                        oil: getTotal("oil"),
                        gas: getTotal("gas"),
                        water: getTotal("water"),
                      },
                    ]}
                  ></AgGridReact>
                </div>
              </div>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
});

